module.exports = __webpack_public_path__ + "img/girl3.de98e384.png";